import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import Card from 'components/Card';
import Page from 'components/Page';
import { observer, inject } from 'mobx-react';
import ProjectsTable, { PROJECT_COLUMNS, PROJECT_CARDS, PROJECT_MIN_TABLE_WIDTH } from 'components/Tables/Projects';
import * as DataList from 'components/DataList';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import ProjectSidebar from '../projects/project-sidebar';

const PageWrapGray = styled('div')`
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'projectStore', 'viewStore') @observer
class ProjectsIndexPage extends Component {

  render() {
    let content;
    const {
      props: {
        projectStore: {
          projects: {
            isLoading,
            isError
          }
        }
      }
    } = this;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={PROJECT_COLUMNS}
          cards={PROJECT_CARDS}
          minTableWidth={PROJECT_MIN_TABLE_WIDTH}
          noun="projects"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="projects" onRetry={() => this.props.projectStore.loadProjects()} />;
    }
    if (!isError && !isLoading) {
      content = <ProjectsTable />
    }
    return (
      <div>
        <PageWrapGray>
          
          <Helmet>
            <title>Projects | FieldNexus</title>
          </Helmet>
          <div className="row no-gutters">
            <div className="col-lg-2 sidebar-responsive">
                <ProjectSidebar />
            </div>
            <div className="col-lg-10">       
              <Page>
              <Sticky enabled={true} top={0} innerZ={9} className="sticky-mobile">
                <SearchBars.Project key={this.props.viewStore.listFiltersVersion} />
              </Sticky>
                <Card>
                  {content}
                </Card>
              </Page>
            </div> 
          </div>
        </PageWrapGray>
        
      </div>
    )
  }

};

export default ProjectsIndexPage;